/**
 * Contract Create Page
 * Thin wrapper that uses the ContractWizard component
 */

import React from 'react';
import { Box } from '@mui/material';
import { ContractWizard } from '../components/contracts/wizard';

function ContractCreate() {
  return (
    <Box sx={{ p: 3 }}>
      <ContractWizard mode="create" />
    </Box>
  );
}

export default ContractCreate;
